import IndexBack from '../auxfuncs/IndexBack.tsx';

const Index = () => {
    return (
        <div>
            <IndexBack/>

            <div className="GradientBackGround">
                <div>
                    <h2 className="CenterText SubBack">
                    Choose a template, complete the form, and download your resume.
                    </h2>
                    
                </div>

            </div>
        </div>
    )
}

export default Index;